import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../hoc/Loading/Loading';
import axios from '../../axios';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import * as url from '../../utils/url';
import SingleGroupMenu from './Components/SingleGroupMenu'
import GroupSettings from './Pages/GroupSettings'
import CreateStoryForm from './Components/GroupStory.jsx'


class SingleGroupSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {  
      name:'',
      privacy:null,
      description:'',
      members:[],
      storyType:null,
      showCreateStoryModal:false,
      topics:[],
      menu:'',
    }
  }

componentDidMount() {
    let{id}=this.props.match.params
    let that=this, resp;
    
    axios.post(url.showGroup, {_id:id, noLoader:true}).then(({ data }) => {
         resp = data.data;
         console.log('group----', resp)

        that.setState({
            name: resp.name,
            group: resp,
            privacy: resp.privacy,
            description: resp.description,
            members: resp.members,
            planning: resp.planning,
            charts: resp.charts,
            tools: resp.tools,
        })
        this.getUrlMenu(resp)
      }).catch((error) => {
        console.log(error);
      })  

      this.getTopics()
     
}




getUrlMenu= group =>{
  let url = `/home/groups/${this.props.user.profile.organizationId._id}/view/${group._id}`
  let current =  this.props.location.pathname
  let res;

  if(current==url){
    res="S"
  } else if(current== (url+"/planning")){
    res="P"
  } else if(current== (url+"/analytics")){
    res="A"
  }else if(current== (url+"/resources")){
    res= "R"
  } else if(current== (url+"/events")){
    res="E"
  } else if(current== (url+"/members") ){
    res="M"
  } 
  
  let{pathname}=this.props.location

  console.log('pathn---', pathname)

  if(pathname==`/home/groups/${this.props.user.profile.organizationId._id}/settings/${group._id}`){
    res=0
  }

  this.highlightMenu(res)
}


highlightMenu = (val) =>{
  this.setState({menu:val})
}


createMarkup = (input) => {
  return { __html: `<div>${input}</div>` };
}
 
renderContent = () => {
    let {searchedPhrase, help, searchedTerm} = this.state
    if(searchedTerm!==""){
        return <div dangerouslySetInnerHTML={this.createMarkup(searchedPhrase)}/>
    }else {
        return <div dangerouslySetInnerHTML={this.createMarkup(help)}/>
    }
}

changeGroupState=(value)=>{
  let obj = {...this.state, ...value}
  this.setState(obj)
}

handleInvitedUsers = mLength =>{
  this.setState({memberCount:mLength+1})
}

getInitials=(user)=>{
  let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
  let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
  return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
}


getTopics = ()=>{
  if(!this.props.user) return
  let orgId = this.props.user.profile.organizationId._id

  axios.get(url.getTopics(orgId)).then(({ data }) => {
    // console.log("data---", data.data)
    let topics = data.data
    this.setState({
      topics: [...topics],
    });
  });
}


toggleCreateStory = (e) => {
  // console.log(e)
  this.setState({ showCreateStoryModal: true, storyType: 'Create Story' })
}

goToPage = menu =>{
  let url = `/home/groups/${this.props.user.profile.organizationId._id}/view/${this.state.group._id}`
  // this.props.history.push(`/home/groups/${this.props.user.profile.organizationId._id}/view/${this.state.group._id}`)
  // menu
  if(menu=='P'){
    this.props.history.push(url+'/planning')
  }else if(menu=='A'){
    this.props.history.push(url+'/analytics')
  }else if(menu=='R'){
    this.props.history.push(url+'/resources')
  }else if(menu=='E'){
    this.props.history.push(url+'/events')
  }else if(menu=='M'){
    this.props.history.push(url+'/members')
  }else if(menu=='S'){
    this.props.history.push(url)
  }
  this.highlightMenu(menu)
}


closeModal=()=>{
  this.setState({showCreateStoryModal:false})
}


renderGroupView=()=>{
  let{menu, group}=this.state
  if(group && group._id){
    return <GroupSettings {...this.state}/>
  }
}

updateGroupMembers=new_mem=>{
  let{members}=this.state

  members=[...members, ...new_mem]

  this.setState({members})
}
updateGroupMembersData=new_mem=>{
  let{members}=this.state

  members=[ ...new_mem]

  this.setState({members})
}

render() {
    let {
      name,
      privacy,
      description,
      invitedUsers,
      memberCount,
      members,
      group,
      menu,
      topics,
      storyType,
      showCreateStoryModal
    }=this.state


    let privacy_status=null
    if(privacy){
      privacy_status = (privacy=='ENTERPRISE'?'Open':privacy=="PRIVATE"?"Private":privacy)
    }
    let profilePic = this.props.user.profile&&this.props.user.profile.profilePic?this.props.user.profile.profilePic:false
    let user_name = `${this.props.user.profile.firstName} ${this.props.user.profile.lastName}`

  return (<span className="grp_single_page_settings_component_container">
    {group && Object.keys(group).length>0?
      <SingleGroupMenu 
      group = {this.state.group}
      updateGroupMembers={this.updateGroupMembers}
      updateGroupMembersData={this.updateGroupMembersData}
      handleInvitedUsers={this.handleInvitedUsers}
      changePrivacy={this.changeGroupState}
      changeGroupName={this.changeGroupState}/>
      :null}
     {/* style={{ textDecoration: 
                this.props.user.organizationId.whiteLabel&&this.props.user.organizationId.whiteLabel.brandColor? 
               `${this.props.user.organizationId.whiteLabel.brandColor}`:'' }} */}
          <div className="grp_single_page_container"> 

          {/* <div className="grp_single_page_details">
            <span className={`grp_page_menu_items ${ menu=='S'? 'grp_menu_item_selected': ''}`}
              onClick={()=>this.goToPage('S')}
              style={whiteLabelStyling(['textDecorationColor'], this.props.user.profile.organizationId, menu!="S")} >
                Posts
              </span>
           
            <span className={`grp_page_menu_items ${ menu=='P'? 'grp_menu_item_selected': ''}`} 
            onClick={()=>this.goToPage('P')} style={whiteLabelStyling(['textDecorationColor'], this.props.user.profile.organizationId, menu!="P")}>
              Planning
            </span>

            <span className={`grp_page_menu_items ${ menu=='A'? 'grp_menu_item_selected': ''}`} 
            onClick={()=>this.goToPage('A')} style={whiteLabelStyling(['textDecorationColor'], this.props.user.profile.organizationId, menu!="A")}>
                Analytics
              </span>
            <span className={`grp_page_menu_items ${ menu=='R'? 'grp_menu_item_selected': ''}`} 
            onClick={()=>this.goToPage('R')} style={whiteLabelStyling(['textDecorationColor'], this.props.user.profile.organizationId, menu!="R")}>
                Resources
              </span>
            <span className={`grp_page_menu_items ${ menu=='E'? 'grp_menu_item_selected': ''}`} 
            onClick={()=>this.goToPage('E')} style={whiteLabelStyling(['textDecorationColor'], this.props.user.profile.organizationId, menu!="E")}>
              Events
              </span>
            <span className={`grp_page_menu_items ${ menu=='M'? 'grp_menu_item_selected': ''}`} 
            onClick={()=>this.goToPage('M')}  style={whiteLabelStyling(['textDecorationColor'], this.props.user.profile.organizationId, menu!="M")}>
                  Members 
              </span>
          </div> */}

          </div>


          <div className="grp_single_page_content">

             

          </div>



      <div className={`grp_single_detail_page_container `}>
          <div className={`grp_single_page_details_container grp_single_page_settings_margin`}>
               {this.renderGroupView()}
               {/* <GroupStories {...this.state}/> */}
          </div>
         




      </div>
     
     
     {group && group.name?
     <CreateStoryForm 
     group={group}
     topics={topics}
     closeModal={this.closeModal} 
     storyType={storyType} 
     showCreateStoryModal={showCreateStoryModal}
    //  topics={this.state.topics}
      // onStoryPublish={this.onStoryPublish.bind(this)} 
      // onStoryCancel={this.closeCreateStoryModal.bind(this)}
      />
      :null}

      </span>
    );
  }
}










const mapStateToProps = state => {
    return {
      user: state.user,
      kpiMaster: state.kpiMaster,
      mappingMaster: state.mappingMaster,
      reports:state.reports
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
      onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
      onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
      updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
      updateReport: (dashboard)=> dispatch(actionCreators.updateReport(dashboard)),
  
    }
  }


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(SingleGroupSettings, axios)));